import React from "react";
import { Accordion } from "react-bootstrap";
import { PlusIcon } from "../../../../styles/img/svg/PlusIcon";
import { UiCol, UiSingleRow } from "../grid-container/GridContainer";

export const UiAccordion = (props) => {
    const terms = props.items;
    return (
        <>
            <div className="sb-accordion-wrapper">
            {terms?.map((term, i) => (
                <Accordion defaultActiveKey={term.id} >
                        <Accordion.Item eventKey= {term.id} key={i}>
                            <Accordion.Header>
                                {term.title}{" "}
                                <span className="sb-accordion-wrapper__plus">
                                    <PlusIcon />
                                </span>
                            </Accordion.Header>
                            <Accordion.Body>
                                {term.description}
                            </Accordion.Body>
                        </Accordion.Item>
                  
                </Accordion>
            ))}

                {/* <Accordion defaultActiveKey={props.defaultActiveKey ? '1' : ''} >
                    {
                        terms.map((term, index) => (
                            <Accordion.Item eventKey={`${term.id}`} key={index}>
                                <UiSingleRow>
                                    <UiCol className="sb-accordion-content">
                                        <Accordion.Header>
                                            {term.title} <span className="sb-accordion-wrapper__plus"><PlusIcon /></span>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            {term.description}
                                        </Accordion.Body>
                                    </UiCol>
                                    {term.image1 &&
                                        <UiCol className="sb-accordion-content-img">
                                            <Accordion.Body>
                                                <div className="sb-left-content-right-image-wrapper__img-sec">
                                                    <img src={term.image1} key={1}/>
                                                    <img src={term.image2} key={2}/>
                                                    <img src={term.image3} key={3}/>
                                                    <img src={term.image4} key={4}/>
                                                </div>
                                            </Accordion.Body>
                                        </UiCol>
                                    }
                                </UiSingleRow>
                            </Accordion.Item>
                        ))
                    }
                </Accordion> */}
            </div>
        </>
    )
}

export const UiAccordionSingleItem = (props) => {

    return (
        <>
            <div className="sb-accordion-wrapper">
                <Accordion defaultActiveKey="0" >

                    <Accordion.Item eventKey="0" key="0">
                        <Accordion.Header>
                            {props.title}   <span className="sb-accordion-wrapper__plus"><PlusIcon /></span>
                        </Accordion.Header>
                        <Accordion.Body>
                            {props.children}
                        </Accordion.Body>
                    </Accordion.Item>

                </Accordion>
            </div>
        </>
    )
}